export const courseContent = {
  week1: {
    title: "Introduction to Resilience and Grit",
    pages: [
      {
        id: 1,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+1/ToT_1_1.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 2,
        type: "multiStep",
        title: "Write a letter to yourself.",
        steps: [
          {
            stepId: 1,
          },
          {
            stepId: 2,
          },
          {
            stepId: 3,
          },
          {
            stepId: 4,
          },
          {
            stepId: 5,
          },
          {
            stepId: 6,
          },
          {
            stepId: 7,
          },
          {
            stepId: 8,
          },
          {
            stepId: 9,
          },
          {
            stepId: 10,
          },
          {
            stepId: 11,
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 3,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+1/ToT_1_2.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 4,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+1/ToT_1_2.mp4",
        type: "showFeelings",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 5,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+1/ToT_1_3.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 6,
        type: "multiStep",
        title: "Write a letter to yourself.",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            challenge:
              "Preparing for a big math test, and you don’t understand all the topics.",
            statement:
              "I don’t understand all the topics. yet., but I can keep studying and practicing until I do",
          },
          {
            stepId: 2,
            type: "imageDragAndDrop",
            instruction:
              "Drag-and-drop the statements on the left into any of these bowls.",
            steps: 4,
            buckets: [
              {
                id: "green",
                title: "Yes",
              },
              {
                id: "red",
                title: "No",
              },
            ],
            images: [
              "Check in if you’ve ever felt frustrated because a student wasn’t listening.",
              "Check in if you’ve ever raised your voice at a student out of frustration.",
              "Check in if you’ve ever dismissed a student's emotions as overreacting.",
              "Check in if you’ve ever judged a student’s ability too quickly.",
              "Check in if you’ve ever assumed a student was lazy without knowing their struggles.",
              "Check in if you’ve ever struggled with self-care because of work stress.",
              "Check in if you’ve ever felt overwhelmed by your responsibilities as a teacher.",
              "Check in if you’ve ever felt unappreciated as a teacher.",
              "Check in if you’ve ever wished you had better tools to support students emotionally.",
              "Check in if you’ve ever doubted your impact on your students.",
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 7,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+1/ToT_1_4.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 8,
        type: "question",
        questionType: "text",
        question:
          "Describe what a classroom without emotional awareness might look like.",
        hasImage: false,
        imageSrc: "mindset.png",
        inputType: "bigTextBox",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 9,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+1/ToT_1_5.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 10,
        type: "multiStep",
        title: "Classroom Decision Making",
        steps: [
          {
            stepId: 1,
            type: "instruction",
          },
          {
            stepId: 2,
            type: "imageDragAndDrop",
            instruction:
              "Drag-and-drop the statements into the appropriate bowl.",
            buckets: [
              {
                id: "green",
                title: "SEL",
              },
              {
                id: "red",
                title: "Not SEL",
              },
            ],
            imagePairs: [
              {
                pairId: 1,
                decisionText:
                  "A student constantly interrupts your lesson, making it hard for others to focus.",
                images: [
                  {
                    id: 0,
                    text: "Call them out in front of the class.",
                  },
                  {
                    id: 1,
                    text: "Kindly caution the student in front of the class. After the lesson, pull them aside later and ask what’s going on.",
                  },
                ],
              },
              {
                pairId: 2,
                decisionText:
                  "A shy student never speaks up, even though you know they have great ideas.",
                images: [
                  {
                    id: 2,
                    text: "Let them stay quiet.",
                  },
                  {
                    id: 3,
                    text: "Find creative ways to boost their confidence.",
                  },
                ],
              },
              {
                pairId: 3,
                decisionText:
                  "A student fails their test and seems really discouraged.",
                images: [
                  {
                    id: 4,
                    text: "Remind them they need to work harder.",
                  },
                  {
                    id: 5,
                    text: "Help them see their progress and plan for improvement.",
                  },
                ],
              },
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 11,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+1/ToT_1_6.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 12,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "instruction",
          },
          {
            stepId: 2,
            type: "dropdownScenario",
            question: "How might this affect your teaching?",
            options: [
              {
                id: "1",
                text: "No effect",
              },
              {
                id: "2",
                text: "Slight impact",
              },
              {
                id: "3",
                text: "Moderate impact",
              },
              {
                id: "4",
                text: "Severe impact",
              },
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 13,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+1/ToT_1_7.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 14,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            title: "Instruction",
            instructions: ["Match the right ‘C’ to their correct definition."],
            options:
              "Competence, Confidence, Coping, Control, Character, Connections, and Contribution.",
          },
          {
            stepId: 2,
            type: "dropdownScenario",
            question:
              "A student realizes they feel anxious before tests and talks to their teacher about it.",
            options: [
              {
                id: "A",
                text: "Self Awareness",
                subText: "(Recognizing emotions & strengths)",
              },
              {
                id: "B",
                text: "Self Management",
                subText: "(Regulating emotions & stress)",
              },
              {
                id: "C",
                text: "Social Awareness",
                subText: "(Empathy & understanding perspectives)",
              },
              {
                id: "D",
                text: "Relationship Skills",
                subText: "(Building positive interactions)",
              },
              {
                id: "E",
                text: "Responsible Decision Making",
                subText: "(Making ethical and safe choices)",
              },
            ],
          },
          {
            stepId: 3,
            type: "dropdownScenario",
            question:
              "A teacher encourages students to start the day by identifying how they feel and why they feel that way.",
            options: [
              {
                id: "A",
                text: "Self Awareness",
                subText: "(Recognizing emotions & strengths)",
              },
              {
                id: "B",
                text: "Self Management",
                subText: "(Regulating emotions & stress)",
              },
              {
                id: "C",
                text: "Social Awareness",
                subText: "(Empathy & understanding perspectives)",
              },
              {
                id: "D",
                text: "Relationship Skills",
                subText: "(Building positive interactions)",
              },
              {
                id: "E",
                text: "Responsible Decision Making",
                subText: "(Making ethical and safe choices)",
              },
            ],
          },
          {
            stepId: 4,
            type: "dropdownScenario",
            question:
              "A teacher notices they are getting overwhelmed and takes a break before responding to a disruptive student.",
            options: [
              {
                id: "A",
                text: "Self Awareness",
                subText: "(Recognizing emotions & strengths)",
              },
              {
                id: "B",
                text: "Self Management",
                subText: "(Regulating emotions & stress)",
              },
              {
                id: "C",
                text: "Social Awareness",
                subText: "(Empathy & understanding perspectives)",
              },
              {
                id: "D",
                text: "Relationship Skills",
                subText: "(Building positive interactions)",
              },
              {
                id: "E",
                text: "Responsible Decision Making",
                subText: "(Making ethical and safe choices)",
              },
            ],
          },
          {
            stepId: 5,
            type: "dropdownScenario",
            question:
              "A student is frustrated with a difficult math problem but takes deep breaths instead of giving up.",
            options: [
              {
                id: "A",
                text: "Self Awareness",
                subText: "(Recognizing emotions & strengths)",
              },
              {
                id: "B",
                text: "Self Management",
                subText: "(Regulating emotions & stress)",
              },
              {
                id: "C",
                text: "Social Awareness",
                subText: "(Empathy & understanding perspectives)",
              },
              {
                id: "D",
                text: "Relationship Skills",
                subText: "(Building positive interactions)",
              },
              {
                id: "E",
                text: "Responsible Decision Making",
                subText: "(Making ethical and safe choices)",
              },
            ],
          },
          {
            stepId: 6,
            type: "dropdownScenario",
            question:
              "A student sees a classmate sitting alone at lunch and invites them to join their group.",
            options: [
              {
                id: "A",
                text: "Self Awareness",
                subText: "(Recognizing emotions & strengths)",
              },
              {
                id: "B",
                text: "Self Management",
                subText: "(Regulating emotions & stress)",
              },
              {
                id: "C",
                text: "Social Awareness",
                subText: "(Empathy & understanding perspectives)",
              },
              {
                id: "D",
                text: "Relationship Skills",
                subText: "(Building positive interactions)",
              },
              {
                id: "E",
                text: "Responsible Decision Making",
                subText: "(Making ethical and safe choices)",
              },
            ],
          },
          {
            stepId: 7,
            type: "dropdownScenario",
            question:
              "A teacher acknowledges a student’s cultural background and adapts their teaching approach accordingly.",
            options: [
              {
                id: "A",
                text: "Self Awareness",
                subText: "(Recognizing emotions & strengths)",
              },
              {
                id: "B",
                text: "Self Management",
                subText: "(Regulating emotions & stress)",
              },
              {
                id: "C",
                text: "Social Awareness",
                subText: "(Empathy & understanding perspectives)",
              },
              {
                id: "D",
                text: "Relationship Skills",
                subText: "(Building positive interactions)",
              },
              {
                id: "E",
                text: "Responsible Decision Making",
                subText: "(Making ethical and safe choices)",
              },
            ],
          },
          {
            stepId: 8,
            type: "dropdownScenario",
            question:
              "Two students disagree in a group project but talk it out instead of arguing.",
            options: [
              {
                id: "A",
                text: "Self Awareness",
                subText: "(Recognizing emotions & strengths)",
              },
              {
                id: "B",
                text: "Self Management",
                subText: "(Regulating emotions & stress)",
              },
              {
                id: "C",
                text: "Social Awareness",
                subText: "(Empathy & understanding perspectives)",
              },
              {
                id: "D",
                text: "Relationship Skills",
                subText: "(Building positive interactions)",
              },
              {
                id: "E",
                text: "Responsible Decision Making",
                subText: "(Making ethical and safe choices)",
              },
            ],
          },
          {
            stepId: 9,
            type: "dropdownScenario",
            question:
              "A teacher models active listening by giving students time to share their thoughts in class.",
            options: [
              {
                id: "A",
                text: "Self Awareness",
                subText: "(Recognizing emotions & strengths)",
              },
              {
                id: "B",
                text: "Self Management",
                subText: "(Regulating emotions & stress)",
              },
              {
                id: "C",
                text: "Social Awareness",
                subText: "(Empathy & understanding perspectives)",
              },
              {
                id: "D",
                text: "Relationship Skills",
                subText: "(Building positive interactions)",
              },
              {
                id: "E",
                text: "Responsible Decision Making",
                subText: "(Making ethical and safe choices)",
              },
            ],
          },
          {
            stepId: 10,
            type: "dropdownScenario",
            question:
              "A teacher encourages students to think about long-term consequences before making choices.",
            options: [
              {
                id: "A",
                text: "Self Awareness",
                subText: "(Recognizing emotions & strengths)",
              },
              {
                id: "B",
                text: "Self Management",
                subText: "(Regulating emotions & stress)",
              },
              {
                id: "C",
                text: "Social Awareness",
                subText: "(Empathy & understanding perspectives)",
              },
              {
                id: "D",
                text: "Relationship Skills",
                subText: "(Building positive interactions)",
              },
              {
                id: "E",
                text: "Responsible Decision Making",
                subText: "(Making ethical and safe choices)",
              },
            ],
          },
          {
            stepId: 11,
            type: "dropdownScenario",
            question:
              "A student goes for their intervention classes instead of going for their friendship group's hangout in the art room.",
            options: [
              {
                id: "A",
                text: "Self Awareness",
                subText: "(Recognizing emotions & strengths)",
              },
              {
                id: "B",
                text: "Self Management",
                subText: "(Regulating emotions & stress)",
              },
              {
                id: "C",
                text: "Social Awareness",
                subText: "(Empathy & understanding perspectives)",
              },
              {
                id: "D",
                text: "Relationship Skills",
                subText: "(Building positive interactions)",
              },
              {
                id: "E",
                text: "Responsible Decision Making",
                subText: "(Making ethical and safe choices)",
              },
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 15,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+1/ToT_1_8.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 16,
        type: "listQuestion",
        question: `“What is Right with Me? (my Strengths)”.`,
        inputCount: 5,
        inputType: "text",
        inputPlaceholder: "Type your answer here",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 17,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+1/ToT_1_9.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 18,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            title: "Instruction",
            instructions: [
              "For this next activity, you will be shown different scenarios. \n Type out the strength you feel is present in that scenario.",
            ],
          },

          {
            stepId: 2,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question: "A student helps a classmate solve a math problem.",
              },
            ],
          },
          {
            stepId: 3,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question: "A student stands up for a friend being teased.",
              },
            ],
          },
          {
            stepId: 4,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question: "A student organizes their group’s project work.",
              },
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 19,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+1/ToT_1_10.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 20,
        type: "listQuestion",
        question: "List out two things you are grateful for.",
        inputCount: 3,
        fields: [
          {
            number: "1",
            textFieldColor: "green",
            colorCode: "#4CB748",
          },
          {
            number: "2",
            textFieldColor: "orange",
            colorCode: "#FDD8B6",
          },
        ],
        inputType: "text",
        inputPlaceholder: "Type your answer here",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 21,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+1/ToT_1_11.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 22,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "dropdownScenario",
            question:
              "Which of these ways is NOT a way to create balance when it comes to prioritizing your well-being?",
            options: [
              {
                id: "A",
                text: "Setting boundaries.",
              },
              {
                id: "B",
                text: "Getting enough rest.",
              },
              {
                id: "C",
                text: "Always covering for your always absent colleague.",
              },
              {
                id: "D",
                text: "Practicing mindfulness",
              },
              {
                id: "E",
                text: "Taking a moment to breathe during a busy school day.",
              },
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 23,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            title: "Instruction",
            instructions: [
              "For this next activity, you will be shown different statements for you to reframe.",
            ],
          },

          {
            stepId: 2,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question:
                  "I sometimes doubt whether I’m making a real difference in my students’ lives.",
              },
            ],
          },
          {
            stepId: 3,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question:
                  "There’s never enough time to get everything done, and I feel overwhelmed",
              },
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 24,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+1/ToT_1_12.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
    ],
  },
  week2: {
    title: "Developing Resilience",
    pages: [
      {
        id: 1,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+2/ToT_2_1.mp4",
        hasNextButton: true,
      },
      {
        id: 2,
        type: "question",
        questionType: "text",
        question: " Type in what you remember from last week.",
        hasImage: false,
        imageSrc: "mindset.png",
        inputType: "bigTextBox",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 3,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+2/ToT_2_2.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 4,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
          },
          {
            stepId: 2,
          },
          {
            stepId: 3,
          },
          {
            stepId: 4,
          },
          {
            stepId: 5,
          },
          {
            stepId: 6,
          },
          {
            stepId: 7,
          },
          {
            stepId: 8,
          },
          {
            stepId: 9,
          },
          {
            stepId: 10,
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 5,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+2/ToT_2_3.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 6,
        type: "multiStep",
        title: "Write a letter to yourself.",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            challenge:
              "In this next activity, we are going to recognize different emotional triggers by grouping them into: ",
            statement: "Mildly triggering, Frustrating and Highly triggering.",
          },
          {
            stepId: 2,
            type: "imageDragAndDrop",
            instruction:
              "Drag-and-drop the statements on the left into any of these bowls.",
            steps: 4,
            buckets: [
              {
                id: "green",
                title: "Mild",
              },
              {
                id: "orange",
                title: "Frustrate",
              },
              {
                id: "red",
                title: "High",
              },
            ],
            images: [
              "A student refuses to follow instructions during a lesson.",
              "A colleague dismisses your idea in a staff meeting.",
              "A student constantly interrupts you while you’re speaking.",
              "A parent questions your teaching methods during a parents-teachers meeting.",
              "A student makes a disrespectful comment about your appearance.",
              "Your head of department gives you negative feedback on your performance unexpectedly.",
              "A student rolls their eyes and mutters something rude during a lesson.",
              "You receive a last-minute schedule change that disrupts your plans for the day.",
              "A student deliberately tries to provoke other students during group work.",
              "A colleague blames you for an issue that wasn't your fault.",
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 7,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+2/ToT_2_4.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 8,
        type: "question",
        questionType: "text",
        question:
          "Which triggers were common for you? Do you think teachers have the same triggers? Why do you think so?",
        hasImage: false,
        imageSrc: "mindset.png",
        inputType: "bigTextBox",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 9,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+2/ToT_2_5.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 10,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            instruction:
              "Answer the following questions to the best of your ability.",
          },

          {
            stepId: 2,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question:
                  "Remember yourself as a student, did you ever feel like one or most of your teachers were like electric kettles waiting to  boil over?",
              },
            ],
          },
          {
            stepId: 3,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question: "How did it feel to be in their classrooms?",
              },
            ],
          },
          {
            stepId: 4,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question:
                  "Did you always look forward to being in their classes?",
              },
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 11,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+2/ToT_2_6.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 12,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "instruction",
          },
          {
            stepId: 2,
            type: "dropdownScenario",
            question:
              "How might this situation affect your emotional response?",
            options: [
              {
                id: "A",
                text: "No emotional change",
              },
              {
                id: "B",
                text: "Slight frustration",
              },
              {
                id: "C",
                text: "Moderate frustration",
              },
              {
                id: "D",
                text: "Severe frustration",
              },
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 13,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+2/ToT_2_6.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 14,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            title: "Instruction",
            instruction:
              "Welcome to the SONAR staircase. You will be presented with a 5 step staircase labeled with the words STOP, OBSERVE, NAME, ASK and REGULATE. You will also be shown 3 scenarios. For each stressful classroom scenario, use the SONAR pathway to walk through your response. Reflect on each step by answering the prompts below.",
          },
          {
            stepId: 2,
            type: "scenario",
            scenarioNumber: 1,
            scenarioType: "textOnly",
            scenarioTitle:
              "A student constantly asks to leave the classroom during lessons, disrupting your teaching.",
            sonarSteps: [
              {
                id: 1,
                stepName: "STOP",
                stepDescription: "Pause and take a breath.",
                question: "What would your default reaction be?",
                width: "100%",
                stepBgColor: "#FFD8DE",
                desBgColor: "#EE2447",
              },
              {
                id: 2,
                stepName: "OBSERVE",
                stepDescription:
                  "Identify what's happening internally and externally.",
                question:
                  "What emotions are you noticing in yourself and the student?",
                width: "90%",
                stepBgColor: "#FFF7E7",
                desBgColor: "#FCAF17",
              },
              {
                id: 3,
                stepName: "NAME",
                stepDescription: "Label the emotion.",
                question: "Why is naming emotions helpful before responding?",
                width: "75%",
                stepBgColor: "#FFCAB7",
                desBgColor: "#904D35",
              },
              {
                id: 4,
                stepName: "ASK",
                stepDescription: "Reflect on the situation.",
                question:
                  "Why is this bothering me? What does the student need?",
                width: "60%",
                stepBgColor: "#FFFFFF",
                desBgColor: "#848484",
              },
              {
                id: 5,
                stepName: "REGULATE",
                stepDescription: "Choose a calm response",
                question:
                  "Address the student privately instead of reacting on the spot",
                width: "50%",
                stepBgColor: "#BBFFD8",
                desBgColor: "#27AE60",
              },
            ],
          },
          {
            stepId: 3,
            type: "scenario",
            scenarioNumber: 2,
            scenarioType: "textOnly",
            scenarioTitle:
              "A parent approaches you after class, expressing dissatisfaction with how their child is being treated in your classroom.",
            sonarSteps: [
              {
                id: 1,
                stepName: "STOP",
                stepDescription: "Pause and take a breath.",
                question: "What would your default reaction be?",
                width: "100%",
                stepBgColor: "#FFD8DE",
                desBgColor: "#EE2447",
              },
              {
                id: 2,
                stepName: "OBSERVE",
                stepDescription:
                  "Identify what's happening internally and externally.",
                question:
                  "What emotions are you noticing in yourself and the parent?",
                width: "90%",
                stepBgColor: "#FFF7E7",
                desBgColor: "#FCAF17",
              },
              {
                id: 3,
                stepName: "NAME",
                stepDescription: "Label the emotion.",
                question: "Why is naming emotions helpful before responding?",
                width: "75%",
                stepBgColor: "#FFCAB7",
                desBgColor: "#904D35",
              },
              {
                id: 4,
                stepName: "ASK",
                stepDescription: "Reflect on the situation.",
                question:
                  "Why is this bothering me? What does the parent need?",
                width: "60%",
                stepBgColor: "#FFFFFF",
                desBgColor: "#848484",
              },
              {
                id: 5,
                stepName: "REGULATE",
                stepDescription: "Choose a calm response",
                question: "Listen actively and schedule a follow-up meeting",
                width: "50%",
                stepBgColor: "#BBFFD8",
                desBgColor: "#27AE60",
              },
            ],
          },
          {
            stepId: 4,
            type: "scenario",
            scenarioNumber: 3,
            scenarioType: "withInput",
            scenarioTitle:
              "Create your own scenario and apply the SONAR method for emotional regulation.",
            sonarSteps: [
              {
                id: 1,
                stepName: "STOP",
                stepDescription: "Pause and take a breath.",
                question: "What would your default reaction be?",
                width: "100%",
                stepBgColor: "#FFD8DE",
                desBgColor: "#EE2447",
              },
              {
                id: 2,
                stepName: "OBSERVE",
                stepDescription:
                  "Identify what's happening internally and externally.",
                question:
                  "What emotions are you noticing in yourself and others?",
                width: "90%",
                stepBgColor: "#FFF7E7",
                desBgColor: "#FCAF17",
              },
              {
                id: 3,
                stepName: "NAME",
                stepDescription: "Label the emotion.",
                question: "Why is naming emotions helpful before responding?",
                width: "75%",
                stepBgColor: "#FFCAB7",
                desBgColor: "#904D35",
              },

              {
                id: 4,
                stepName: "ASK",
                stepDescription: "Reflect on the situation.",
                question:
                  "Why is this bothering me? What does the other person need?",
                width: "60%",
                stepBgColor: "#FFFFFF",
                desBgColor: "#848484",
              },
              {
                id: 5,
                stepName: "REGULATE",
                stepDescription: "Choose a calm response",
                question: "What calm, thoughtful response could you choose?",
                width: "50%",
                stepBgColor: "#BBFFD8",
                desBgColor: "#27AE60",
              },
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 15,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+2/ToT_2_6.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 16,
        type: "multiStep",
        title: "Teacher Response Ranking",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            instructions: [
              "On the screen, you'll see Scenario Flashcards that describe classroom situations involving student emotions.",
              "You will also see Response Flashcards, each presenting a possible teacher reaction. Drag the response cards to rank them from least to most effective.",
              "Afterward, reflect on why you chose the responses you did.",
            ],
          },
          {
            stepId: 2,
            type: "scenario",
            scenarioNumber: 1,
            scenarioText:
              'A student rolls their eyes and mutters: "This is so boring".',
          },
          {
            stepId: 3,
            type: "dragAndDropRanking",
            scenarioNumber: 1,
            responses: [
              { id: "response_1", text: "Ignore the behavior" },
              { id: "response_2", text: "Call them out in front of the class" },
              {
                id: "response_3",
                text: "Acknowledge their feelings and redirect focus",
              },
              {
                id: "response_4",
                text: "Tell them to see you after the class",
              },
            ],
            rankingSlots: [
              { rank: 4, label: "4" },
              { rank: 3, label: "3" },
              { rank: 2, label: "2" },
              { rank: 1, label: "1" },
            ],
          },
          {
            stepId: 4,
            type: "scenario",
            scenarioNumber: 2,
            scenarioText: "A student starts crying in the middle of class.",
          },
          {
            stepId: 5,
            type: "dragAndDropRanking",
            scenarioNumber: 2,
            responses: [
              { id: "response_1", text: "Ignore the behavior" },
              { id: "response_2", text: "Call them out in front of the class" },
              {
                id: "response_3",
                text: "Acknowledge their feelings and redirect focus",
              },
              {
                id: "response_4",
                text: "Tell them to see you after the class",
              },
            ],
            rankingSlots: [
              { rank: 4, label: "4" },
              { rank: 3, label: "3" },
              { rank: 2, label: "2" },
              { rank: 1, label: "1" },
            ],
          },
          {
            stepId: 6,
            type: "scenario",
            scenarioNumber: 3,
            scenarioText:
              "A student becomes defensive and raises their voice when you ask them to stop talking during a group activity.",
          },
          {
            stepId: 7,
            type: "dragAndDropRanking",
            scenarioNumber: 3,
            responses: [
              { id: "response_1", text: "Ignore the behavior" },
              { id: "response_2", text: "Call them out in front of the class" },
              {
                id: "response_3",
                text: "Acknowledge their feelings and redirect focus",
              },
              {
                id: "response_4",
                text: "Tell them to see you after the class",
              },
            ],
            rankingSlots: [
              { rank: 4, label: "4" },
              { rank: 3, label: "3" },
              { rank: 2, label: "2" },
              { rank: 1, label: "1" },
            ],
          },
          {
            stepId: 8,
            type: "scenario",
            scenarioNumber: 4,
            scenarioText:
              "A student shuts down and refuses to participate after seeing a 40% in their project.",
          },
          {
            stepId: 9,
            type: "dragAndDropRanking",
            scenarioNumber: 4,
            responses: [
              { id: "response_1", text: "Ignore the behavior" },
              { id: "response_2", text: "Call them out in front of the class" },
              {
                id: "response_3",
                text: "Acknowledge their feelings and redirect focus",
              },
              {
                id: "response_4",
                text: "Tell them to see you after the class",
              },
            ],
            rankingSlots: [
              { rank: 4, label: "4" },
              { rank: 3, label: "3" },
              { rank: 2, label: "2" },
              { rank: 1, label: "1" },
            ],
          },
          {
            stepId: 10,
            type: "reflection",
            question: "Which response encourages self-regulation?",
          },
          {
            stepId: 11,
            type: "reflection",
            question: "Which response might escalate the situation?",
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 17,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+2/ToT_2_7.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
    ],
  },
  week3: {
    title: "Understanding the Concept of Adaptability and Its Application",
    pages: [
      {
        id: 1,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+3/Week+3_1.mp4",
        hasNextButton: true,
      },
      {
        id: 2,
        type: "multiStep",
        title: "Write a letter to yourself.",
        steps: [
          {
            stepId: 1,
          },
          {
            stepId: 2,
          },
          {
            stepId: 3,
          },
          {
            stepId: 4,
          },
          {
            stepId: 5,
          },
          {
            stepId: 6,
          },
          {
            stepId: 7,
          },
          {
            stepId: 8,
          },
          {
            stepId: 9,
          },
          {
            stepId: 10,
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 3,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+3/Week+3_2.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },

      {
        id: 4,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question:
                  "Think of a student you found difficult to connect with. What got in the way?",
              },
            ],
          },
          {
            stepId: 2,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question:
                  "What helped you build a better relationship with them over time?",
              },
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },

      {
        id: 5,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+3/Week+3_3.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 6,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            title: "Instruction",
            instructions: [
              "Building connections with your students takes small but powerful activities and moments. In this next activity, you will be presented with different behaviors and scenarios. Select the appropriate behavior tha matches each scenario from the dropdown.",
            ],
            options:
              "Competence, Confidence, Coping, Control, Character, Connections, and Contribution.",
          },
          {
            stepId: 2,
            type: "dropdownScenario",
            question:
              "A student seems withdrawn after failing a test. The teacher sits with them privately, acknowledges their feelings, and helps them create a study plan.",
            options: [
              {
                id: "A",
                text: "Active Listening",
              },
              {
                id: "B",
                text: "Encouragement & Praise",
              },
              {
                id: "C",
                text: "Fairness & Consistency",
              },
              {
                id: "D",
                text: "Emotional Support",
              },
              {
                id: "E",
                text: "Showing Interest in Students' Lives",
              },
            ],
          },
          {
            stepId: 3,
            type: "dropdownScenario",
            question:
              "During a class discussion, a teacher repeats and validates a quiet student’s point, making sure their voice is heard.",
            options: [
              {
                id: "A",
                text: "Active Listening",
              },
              {
                id: "B",
                text: "Encouragement & Praise",
              },
              {
                id: "C",
                text: "Fairness & Consistency",
              },
              {
                id: "D",
                text: "Emotional Support",
              },
              {
                id: "E",
                text: "Showing Interest in Students' Lives",
              },
            ],
          },
          {
            stepId: 4,
            type: "dropdownScenario",
            question: `A student struggles with a task but keeps trying. The teacher praises their persistence, saying, "I love how you’re not giving up!"`,
            options: [
              {
                id: "A",
                text: "Active Listening",
              },
              {
                id: "B",
                text: "Encouragement & Praise",
              },
              {
                id: "C",
                text: "Fairness & Consistency",
              },
              {
                id: "D",
                text: "Emotional Support",
              },
              {
                id: "E",
                text: "Showing Interest in Students' Lives",
              },
            ],
          },
          {
            stepId: 5,
            type: "dropdownScenario",
            question:
              "A teacher ensures that all students take turns answering questions, even the quieter ones, and applies the same classroom rules to everyone.",
            options: [
              {
                id: "A",
                text: "Active Listening",
              },
              {
                id: "B",
                text: "Encouragement & Praise",
              },
              {
                id: "C",
                text: "Fairness & Consistency",
              },
              {
                id: "D",
                text: "Emotional Support",
              },
              {
                id: "E",
                text: "Showing Interest in Students' Lives",
              },
            ],
          },
          {
            stepId: 6,
            type: "dropdownScenario",
            question:
              "Before class, a teacher casually asks a student about their weekend football match and remembers to check in later on how it went.",
            options: [
              {
                id: "A",
                text: "Active Listening",
              },
              {
                id: "B",
                text: "Encouragement & Praise",
              },
              {
                id: "C",
                text: "Fairness & Consistency",
              },
              {
                id: "D",
                text: "Emotional Support",
              },
              {
                id: "E",
                text: "Showing Interest in Students' Lives",
              },
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 7,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+3/Week+3_4.mp4",
        hasNextButton: true,
      },
      {
        id: 8,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question: "How do you think the student feels?",
              },
            ],
          },
          {
            stepId: 2,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question: "How do you think the student feels?",
              },
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 9,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+3/Week+3_5.mp4",
        hasNextButton: true,
      },
      {
        id: 10,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            title: "Instruction",
            instructions: [
              "Identify the strength being displayed and then write a short praise statement that reinforces this behavior. An example has been done for you.",
            ],
          },

          {
            stepId: 2,
            type: "example",
            questions: [
              {
                type: "Question",
                question:
                  "A student works diligently on a task they find difficult, showing improvement over time.",
              },
            ],
          },
          {
            stepId: 3,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question:
                  "A student actively participates in group discussions, offering insightful comments and listening to others.",
              },
            ],
          },
          {
            stepId: 4,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question:
                  "A student is kind to a peer who is feeling upset, offering comfort and support without being asked.",
              },
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 11,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+3/Week+3_6.mp4",
        hasNextButton: true,
      },
      {
        id: 12,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            title: "Instruction",
            instructions: [
              "Read the following scenario and write a response that encourages reflection (what was happening for you when you were talking out of turn?), responsibility (when you talk out of turn, it disrupts everyone’s learning), and repairing (what can we do to ensure everyone has a chance to speak during the lesson?) the relationship with the student. \nThink about how your response can guide the student toward understanding the impact of their actions, taking responsibility, and making amends.",
            ],
          },

          {
            stepId: 2,
            type: "scenario",
            questions: [
              {
                type: "scenario",
                question:
                  "A student has repeatedly been talking out of turn during your class, disrupting the flow of the class. Despite being cautioned several times, they continue to ignore your warnings. Your response should include three simple components:",
              },
            ],
          },
          {
            stepId: 3,
            type: "question",
            questions: [
              {
                type: "reflect",
                question:
                  "A question for the student to reflect on their behavior:",
              },
              {
                type: "explain",
                question:
                  "A statement explaining how their actions affect others:",
              },
              {
                type: "suggestion",
                question:
                  "A suggestion for how they can improve in the future:",
              },
            ],
          },
          {
            stepId: 4,
            type: "scenario",
            questions: [
              {
                type: "scenario",
                question:
                  "A group of students were asked to work as a group in science class.During this exercise, you noticed a student ran out of the classroom in tears. Further investigation revealed that another student in the group made a teasing comment, but the first student did not find it funny. The second student has refused to apologise because they believe they have done nothing wrong, claiming it was a joke.",
              },
            ],
          },
          {
            stepId: 5,
            type: "question",
            questions: [
              {
                type: "reflect",
                question:
                  "A question for the student to reflect on their behavior:",
              },
              {
                type: "explain",
                question:
                  "A statement explaining how their actions affect others:",
              },
              {
                type: "suggestion",
                question:
                  "A suggestion for how they can improve in the future:",
              },
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 13,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+3/Week+3_7.mp4",
        hasNextButton: true,
      },
    ],
  },
  week4: {
    title: "The Role of Support Systems",
    pages: [
      {
        id: 1,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+4/Week+4_1.mp4",
        hasNextButton: true,
      },
      {
        id: 2,
        type: "multiStep",
        title: "Write a letter to yourself.",
        steps: [
          {
            stepId: 1,
          },
          {
            stepId: 2,
          },
          {
            stepId: 3,
          },
          {
            stepId: 4,
          },
          {
            stepId: 5,
          },
          {
            stepId: 6,
          },
          {
            stepId: 7,
          },
          {
            stepId: 8,
          },
          {
            stepId: 9,
          },
          {
            stepId: 10,
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 3,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+4/Week+4_2.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 4,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question: "What does the word, ‘Growth Mindset’ mean to you?",
              },
            ],
          },
          {
            stepId: 2,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question:
                  "Is ‘Resilience’ a word familiar to you? What does it mean?",
              },
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 5,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+4/Week+4_2.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 6,
        type: "question",
        questionType: "text",
        question:
          "From what I have explained so far, give an example of a statement that shows a fixed mindset.",
        hasImage: false,
        imageSrc: "mindset.png",
        inputType: "bigTextBox",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 7,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+4/Week+4_2.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 8,
        type: "multiStep",
        title: "Write a letter to yourself.",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            instruction:
              "Drag the statements that show a fixed mindset into the fixed mindset box and the statements that show a growth mindset to the appropriate box. This activity will help you practice how to identify fixed and growth mindset thinking patterns in everyday scenarios.",
          },

          {
            stepId: 2,
            type: "imageDragAndDrop",
            instruction:
              "Drag-and-drop the statements on the left into any of these bowls.",
            steps: 4,
            buckets: [
              {
                id: "green",
                title: "Growth Mindset",
              },
              {
                id: "red",
                title: "Fixed Mindset",
              },
            ],
            images: [
              "I can’t do this.",
              "I can learn this if I keep trying.",
              "This is tough now, but I’ll get better over time.",
              "This subject just isn't for me.",
              "Mistakes help me grow.",
              "This is for new age teachers, I am not one of them.",
              "This may take time and effort.",
              "I failed this time, so I’ll probably keep failing.",
              "I hate making mistakes, it means I’m not smart.",
              "I haven’t figured it out yet—but I will.",
            ],
          },
          {
            stepId: 3,
            type: "question",
            question:
              "Which of these thoughts have you heard from your students or caught yourself saying?",
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 9,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+4/Week+4_3.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 10,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            title: "Instruction",
            instructions: [
              "Let us reflect on our own journey as educator, the highs and the lows and how we have developed resilience in our own experiences.",
              "Click each box starting from number 1 to answer the guiding questions. Simply type in your reflections.",
            ],
          },
          {
            stepId: 2,
            type: "careerLadder",
            boxes: [
              {
                id: 5,
                text: "5. Current Focus",
                color: "green",
                bgColor: "#27AE60",
                questions: [
                  {
                    id: 1,
                    question:
                      "What area in your teaching profession do you want to build resilience?",
                    subQuestion:
                      "“Right now, I want to grow stronger in the area of…”",
                  },
                  {
                    id: 2,
                    question: "What support or mindset shift could help?",
                    subQuestion: `“One thing that could support me in this area is…”`,
                  },
                ],
              },
              {
                id: 4,
                text: "4. Recent Success",
                color: "gray",
                bgColor: "#848484",
                questions: [
                  {
                    id: 1,
                    question: "Think of a recent moment that made you proud.",
                    subQuestion: `“One recent teaching moment that made me proud was…”`,
                  },
                  {
                    id: 2,
                    question: "What personal strengths contributed to it?",
                    subQuestion: `“I believe that my ability to ______ helped me succeed in that moment.”`,
                  },
                ],
              },
              {
                id: 3,
                text: "3. Turning Point",
                color: "brown",
                bgColor: "#904D35",
                questions: [
                  {
                    id: 1,
                    question:
                      "What experience helped you shift, grow, or bounce back?",
                    subQuestion: `“A turning point for me as an educator was when…”`,
                  },
                  {
                    id: 2,
                    question: "What lessons did you learn?",
                    subQuestion: `“That experience taught me that…”`,
                  },
                ],
              },
              {
                id: 2,
                text: "2. Early Challenge",
                color: "yellow",
                bgColor: "#FCAF17",
                questions: [
                  {
                    id: 1,
                    question: "Describe a difficult experience early on.",
                    subQuestion: `“One challenge I faced early in my teaching career was…”`,
                  },
                  {
                    id: 2,
                    question: "How did you handle it at the time?",
                    subQuestion: `“At the time, I responded by….”`,
                  },
                ],
              },
              {
                id: 1,
                text: "1. Start of Teaching Career",
                color: "red",
                bgColor: "#EE2447",
                questions: [
                  {
                    id: 1,
                    question: "What motivated you to become a teacher?",
                    subQuestion: `“One reason I felt called to teaching was…”`,
                  },
                  {
                    id: 2,
                    question: "What were your hopes or fears when you started?",
                    subQuestion: `“When I first started teaching, I hoped that… but I also worried that…”`,
                  },
                ],
              },
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 11,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+4/Week+4_4.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 12,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            title: "Instruction",
            instructions: [
              "In this next activity, you'll practice shifting from fixed-mindset praise to growth-oriented feedback, so you can help your students stay motivated, especially when learning gets tough.",
            ],
          },

          {
            stepId: 2,
            type: "example",
            questions: [
              {
                type: "Question",
                question:
                  "A student works diligently on a task they find difficult, showing improvement over time.",
              },
            ],
          },
          {
            stepId: 3,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question: "You got it right on the first try.",
              },
            ],
          },
          {
            stepId: 4,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question: "This is too hard for you.",
              },
            ],
          },
          {
            stepId: 5,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question: "You keep making the same mistake.",
              },
            ],
          },
          {
            stepId: 6,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question: "Don’t worry, this just isn’t your strength.",
              },
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 13,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+4/Week+4_5.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 14,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            title: "Instruction",
            instructions: [
              "Take this moment to pause, acknowledge your growth, and set intentions for the educator you want to be moving forward.",
            ],
          },
          {
            stepId: 2,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question:
                  "What challenge in your teaching journey did you once think you couldn’t overcome, but did?",
              },
            ],
          },
          {
            stepId: 3,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question: "A student stands up for a friend being teased.",
              },
            ],
          },
          {
            stepId: 4,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question: "A student organizes their group’s project work.",
              },
            ],
          },
          {
            stepId: 5,
            type: "scenario",
            questions: [
              {
                type: "Question",
                question:
                  "What’s one thing you’ve learned that made you a better teacher?",
              },
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 15,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+4/Week+4_6.mp4",
        hasNextButton: true,
      },
    ],
  },
  week5: {
    title: "Coping Skills",
    pages: [
      {
        id: 1,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+5/Week+5_1.mp4",
        hasNextButton: true,
      },
      {
        id: 2,
        type: "multiStep",
        title: "Write a letter to yourself.",
        steps: [
          {
            stepId: 1,
          },
          {
            stepId: 2,
          },
          {
            stepId: 3,
          },
          {
            stepId: 4,
          },
          {
            stepId: 5,
          },
          {
            stepId: 6,
          },
          {
            stepId: 7,
          },
          {
            stepId: 8,
          },
          {
            stepId: 9,
          },
          {
            stepId: 10,
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 3,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+5/Week+5_2.mp4",
        hasNextButton: true,
      },
      {
        id: 4,
        type: "question",
        questionType: "text",
        question:
          "Sincerely, do you think SEL can be incorporated into EVERY single subject?",
        hasImage: false,
        imageSrc: "mindset.png",
        inputType: "bigTextBox",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 5,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+5/Week+5_3.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 6,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            title: "Instruction",
            instructions: [
              "The next activity helps you think about how to intentionally use storytelling to spark meaningful conversations in your classroom. \nSelect the appropriate SEL skills that matches the story.",
            ],
            options:
              "Competence, Confidence, Coping, Control, Character, Connections, and Contribution.",
          },
          {
            stepId: 2,
            type: "question",
            question: [
              {
                type: "subject",
                question: "Subject:",
              },
              {
                type: "skill",
                question: "SEL Skill:",
              },
            ],
            inputType: "text",
            inputPlaceholder: "Type your answer here",
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 7,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+5/Week+5_3.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 8,
        type: "question",
        questions: [
          {
            type: "game",
            question: "Name of Game:",
          },
          {
            type: "instructions",
            question: "Instructions:",
          },
          {
            type: "connection",
            question: "SEL Connection:",
          },
        ],
        inputType: "text",
        inputPlaceholder: "Type your answer here",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 9,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+5/Week+5_4.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 10,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            title: "Instruction",
            instructions: [
              "The next activity helps you think about how to intentionally use storytelling to spark meaningful conversations in your classroom. \nSelect the appropriate SEL skills that matches the story.",
            ],
            options:
              "Competence, Confidence, Coping, Control, Character, Connections, and Contribution.",
          },
          {
            stepId: 2,
            type: "dropdownScenario",
            question:
              "Tunde failed his first Spanish test. Instead of giving up, he asked for help and practiced every evening until he improved.",
            options: [
              {
                id: "A",
                text: "Self-awareness & Emotional Regulation",
              },
              {
                id: "B",
                text: "Resilience",
              },
              {
                id: "C",
                text: "Empathy",
              },
              {
                id: "D",
                text: "Collaboration & Social Awareness",
              },
            ],
          },
          {
            stepId: 3,
            type: "dropdownScenario",
            question:
              "During a class discussion, a teacher repeats and validates a quiet student’s point, making sure their voice is heard.",
            options: [
              {
                id: "A",
                text: "Self-awareness & Emotional Regulation",
              },
              {
                id: "B",
                text: "Resilience",
              },
              {
                id: "C",
                text: "Empathy",
              },
              {
                id: "D",
                text: "Collaboration & Social Awareness",
              },
            ],
          },
          {
            stepId: 4,
            type: "dropdownScenario",
            question: `Amina noticed her classmate was upset. She sat with her, listened to her problems, and comforted her by sharing a similar experience."`,
            options: [
              {
                id: "A",
                text: "Self-awareness & Emotional Regulation",
              },
              {
                id: "B",
                text: "Resilience",
              },
              {
                id: "C",
                text: "Empathy",
              },
              {
                id: "D",
                text: "Collaboration & Social Awareness",
              },
            ],
          },
          {
            stepId: 5,
            type: "dropdownScenario",
            question:
              "Chijioke always knew he could do math, but when a difficult problem came up, he froze. After speaking with his teacher and some reflection, he realized he needed to stay calm and keep trying.",
            options: [
              {
                id: "A",
                text: "Self-awareness & Emotional Regulation",
              },
              {
                id: "B",
                text: "Resilience",
              },
              {
                id: "C",
                text: "Empathy",
              },
              {
                id: "D",
                text: "Collaboration & Social Awareness",
              },
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 11,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+5/Week+5_5.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 12,
        type: "question",
        questionType: "text",
        question:
          "Document your current classroom routines. Make it simple, realistic, and something you do consistently.",
        hasImage: false,
        imageSrc: "mindset.png",
        inputType: "bigTextBox",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 13,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+5/Week+5_6.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
    ],
  },
  week6: {
    title: "Coping Skills",
    pages: [
      {
        id: 1,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+6/Week+6_1.mp4",
        hasNextButton: true,
      },
      {
        id: 2,
        type: "question",
        questionType: "text",
        question:
          "Have you ever seen a match stick light up other matchsticks when it is lit? \n\nNow, imagine that the match stick goes off, would it still be able to light other matchsticks?",
        hasImage: false,
        imageSrc: "mindset.png",
        inputType: "bigTextBox",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 3,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+6/Week+6_3.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 4,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            title: "Instruction",
            instructions: [
              "Below are six statements related to how you may have been feeling recently. For each one, choose the option that best reflects your experience:  Never, Occasionally, Frequently, Always.",
            ],
            options:
              "Competence, Confidence, Coping, Control, Character, Connections, and Contribution.",
          },
          {
            stepId: 2,
            type: "dropdownScenario",
            question: "I often feel emotionally drained.",
            options: [
              {
                id: "A",
                text: "Never",
              },
              {
                id: "B",
                text: "Occasionally",
              },
              {
                id: "C",
                text: "Frequently",
              },
              {
                id: "D",
                text: "Always",
              },
            ],
          },
          {
            stepId: 3,
            type: "dropdownScenario",
            question: "I feel disconnected from my students.",
            options: [
              {
                id: "A",
                text: "Never",
              },
              {
                id: "B",
                text: "Occasionally",
              },
              {
                id: "C",
                text: "Frequently",
              },
              {
                id: "D",
                text: "Always",
              },
            ],
          },
          {
            stepId: 4,
            type: "dropdownScenario",
            question: `I find myself getting easily irritated by small things recently.`,
            options: [
              {
                id: "A",
                text: "Never",
              },
              {
                id: "B",
                text: "Occasionally",
              },
              {
                id: "C",
                text: "Frequently",
              },
              {
                id: "D",
                text: "Always",
              },
            ],
          },
          {
            stepId: 5,
            type: "dropdownScenario",
            question:
              "I struggle to fall asleep, stay asleep, or feel rested in the mornings.",
            options: [
              {
                id: "A",
                text: "Never",
              },
              {
                id: "B",
                text: "Occasionally",
              },
              {
                id: "C",
                text: "Frequently",
              },
              {
                id: "D",
                text: "Always",
              },
            ],
          },
          {
            stepId: 6,
            type: "dropdownScenario",
            question:
              "I feel like I’m constantly behind or drowning in responsibilities.",
            options: [
              {
                id: "A",
                text: "Never",
              },
              {
                id: "B",
                text: "Occasionally",
              },
              {
                id: "C",
                text: "Frequently",
              },
              {
                id: "D",
                text: "Always",
              },
            ],
          },
          {
            stepId: 7,
            type: "dropdownScenario",
            question:
              "I often experience headaches, body tension, or stomach issues during the workday.",
            options: [
              {
                id: "A",
                text: "Never",
              },
              {
                id: "B",
                text: "Occasionally",
              },
              {
                id: "C",
                text: "Frequently",
              },
              {
                id: "D",
                text: "Always",
              },
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 5,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+6/Week+6_2.mp4",
        hasNextButton: true,
      },
      {
        id: 6,
        type: "listQuestion",
        question:
          "Write down three ways you recharge whenever you feel burnout.",
        inputCount: 3,
        inputType: "text",
        inputPlaceholder: "Type your answer here",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 7,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+6/Week+6_3.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 8,
        type: "question",
        questionType: "text",
        question:
          "What is one moment from your recent teaching experience that made you feel grateful? It could be a student’s progress, a kind gesture from a colleague, or even something small, like a quiet moment before class started.",
        hasImage: false,
        imageSrc: "mindset.png",
        inputType: "bigTextBox",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 9,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+6/Week+6_4.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 10,
        type: "multiStep",
        title: "Write a letter to yourself.",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            challenge:
              "Drag and drop each item into the circle where it best fits. \nFor example, close colleagues might belong in your Inner Circle, while a school wellness program could go in the Middle Circle. \nA potential partnership with a community organization would fit into the Outer Circle.",
            statement: "Mildly triggering, Frustrating and Highly triggering.",
          },
          {
            stepId: 2,
            type: "imageDragAndDrop",
            instruction:
              "Drag-and-drop the statements on the left into any of these bowls.",
            steps: 4,
            buckets: [
              {
                id: "green",
                title: "Inner Circle",
              },
              {
                id: "orange",
                title: "Middle Circle",
              },
              {
                id: "red",
                title: "Outer Circle",
              },
            ],
            images: [
              "Close colleagues or team members",
              "Immediate family",
              "A trusted friend",
              "Daily self-care practices (e.g., mindfulness, exercise, watching favourite movie)",
              "Classroom routines that bring calm (e.g., breaks)",
              "Student support (e.g., positive relationships with students)",
              "School counselor",
              "Mentor or senior colleague",
              "Online support groups or communities",
              "Principal or school leadership team",
              "School wellness programs",
              "SEL and Positive Psychology workshops",
              "Partnerships with parents or caregivers",
              "Peer teacher groups or networks",
            ],
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 11,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+6/Week+6_5.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 12,
        type: "multiStep",
        steps: [
          {
            stepId: 1,
            type: "instruction",
            title: "Instruction",
            instructions: [
              "Now that you've reflected on your own well-being and support systems, it's time to create your own SEL and Positive Psychology Implementation Plan.",
              "This plan will help you bring SEL to life in your classroom consistently and sustainably. It's not about perfection, it's about purpose!",
            ],
          },
          {
            stepId: 2,
            type: "onboarding",
            title: "SEL & Positive Psychology Implementation Plan Worksheet.",
            subtitle:
              "Your personal roadmap to building an emotionally intelligent and thriving classroom.",
          },
          {
            stepId: 3,
            type: "section",
            sectionNumber: 1,
            sectionTitle: "Section 1",
            questionFocus: "My Why:",
            question:
              "Why does Social and Emotional Learning (SEL) matter to me as a teacher?",
            cheatSheet:
              "Reflect on your personal motivation for incorporating SEL and positive psychology into your teaching.",
            inputType: "bigTextBox",
          },
          {
            stepId: 4,
            type: "section",
            sectionNumber: 2,
            sectionTitle: "Section 2",
            questionFocus: " My Focus Areas:",
            question:
              "What are the top 3 SEL or Positive Psychology skills I want to focus on with my students this term?",
            cheatSheet:
              "(e.g., empathy, emotional regulation, gratitude, growth mindset, responsible decision-making)",
            inputType: "bigTextBox",
          },
          {
            stepId: 5,
            type: "section",
            sectionNumber: 3,
            sectionTitle: "Section 3",
            questionFocus: "Integration Into My Teaching:",
            question:
              "How will I integrate SEL and positive psychology into my subject or classroom routines?",
            cheatSheet:
              "Tick the methods you plan to use and describe briefly how you’ll do it.",
            inputType: "checkboxWithOther",
            checkboxOptions: [
              { id: "morning-check-ins", label: "Morning check-ins" },
              {
                id: "emotional-vocabulary-in-lessons",
                label: "Emotional vocabulary in lessons",
              },
              { id: "gratitude-journals", label: "Gratitude journals" },
              { id: "relationship_skills", label: "Relationship Skills" },
              {
                id: "breathing_or_grounding_exercises",
                label: "Breathing or grounding exercises",
              },
              { id: "weekly_class_meetings", label: "Weekly class meetings" },
              {
                id: "praise_for_effort,_not_just_results",
                label: "Praise for effort, not just results",
              },
              {
                id: "growth_mindset_reflections",
                label: "Growth mindset reflections",
              },
              {
                id: "cooperative_learning_tasks",
                label: "Cooperative learning tasks",
              },
              {
                id: "storytelling_or_character_analysis",
                label: "Storytelling or character analysis",
              },
            ],
            additionalFields: [
              {
                label: "Others:",
                type: "bigTextBox",
              },
              {
                label: "My integration plan (brief description):",
                type: "bigTextBox",
              },
            ],
          },
          {
            stepId: 6,
            type: "section",
            sectionNumber: 4,
            sectionTitle: "Section 4",
            questionFocus: "Modeling SEL and Positivity:",
            question:
              "How will I model these values and skills in my own behavior?",
            cheatSheet:
              "(e.g., practicing self-regulation, showing optimism, expressing appreciation)",
            inputType: "bigTextBox",
          },
          {
            stepId: 7,
            type: "section",
            sectionNumber: 5,
            sectionTitle: "Section 5",
            questionFocus: "My Support System:",
            question:
              "What support will I need to stay consistent and motivated?",
            cheatSheet:
              "(Who or what can help you keep going—colleagues, resources, routines?)",
            inputType: "bigTextBox",
          },
          {
            stepId: 8,
            type: "section",
            sectionNumber: 6,
            sectionTitle: "Section 6",
            questionFocus: "My First Steps:",
            question:
              "What are 2 small actions I will take in the next 2 weeks?",
            cheatSheet: "Start simple. Focus on building momentum.",
            inputType: "twoSmallInputs",
            additionalFields: [
              {
                questionFocus: "Collaboration:",
                question:
                  "Would you like to share your plan with a peer or small group for feedback and encouragement?",
                cheatSheet:
                  "(This can be done through a discussion forum, breakout group, or collaborative session.)",
                type: "bigTextBox",
              },
            ],
          },
          {
            stepId: 9,
            type: "section",
            sectionNumber: 7,
            sectionTitle: "Section 7",
            questionFocus: "Final Note to Myself:",
            question:
              "What encouragement or reminder do I want to leave for myself today?",
            inputType: "bigTextBox",
          },
        ],
        navigation: {
          prev: true,
          next: true,
        },
      },
      {
        id: 13,
        type: "video",
        videoSrc:
          "https://d3sc34m1n26ele.cloudfront.net/tot1_videos/Week+6/Week+6_6.mp4",
        navigation: {
          prev: true,
          next: true,
        },
      },
    ],
  },
};
